import { buildControllerRules } from "@gettactic/helpers/src/hook-form/buildControllerRules";
import { buildErrorMessageForName } from "@gettactic/helpers/src/hook-form/buildErrorMessageForName";
import React from "react";
import { FieldValues } from "react-hook-form";
import { TextareaInput } from "./TextareaInput";
import { HookFormTextareaInputProps } from "./TextareaInput.types";

export const HookFormTextareaInput = <T extends FieldValues>(
  props: HookFormTextareaInputProps<T>
): React.ReactElement => {
  const { form, name, rules, ...rest } = props;
  return (
    <TextareaInput
      {...form.register(
        name,
        buildControllerRules({
          form,
          name,
          rules,
          isRequired: props.isRequired
        })
      )}
      error={buildErrorMessageForName(form, name)}
      {...rest}
    />
  );
};
